import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./NavBar";
import { Banner } from "./Banner";
import { Skills } from "./Skills";
import { Projects } from "./Projects";
import { Footer } from "./Footer";
import Bruh from "./name.mp3";
import ReactAudioPlayer from 'react-audio-player';
import {Helmet} from "react-helmet";
import React from 'react'
import ReactDOM from 'react-dom'
import Favicon from 'react-favicon'
import Snowfall from 'react-snowfall'
import SupportEngine from '../SupportEngine';
import { BrowserRouter, Route  } from 'react-router-dom';
import Switch from "react-switch";
import Spline from '@splinetool/react-spline';
import { Model } from './Model';
import OpenAı from './Dalle-E/OpenAı';





export const Main = () => {
    return (
        <section className="App">
        {/*<Favicon url="./favicon.ico"/>  */}
        <Snowfall
            snowflakeCount={0}
        />
        <Helmet>
            <meta charSet="utf-8" />
            <title>SPİCCATO</title>
            <link rel="canonical" href="http://spiccatogames.com" />
        </Helmet>
        <ReactAudioPlayer
            src={Bruh}
            loop ={true}
            controls={false}
            autoPlay={true}
        />
        {/*Navbar*/}
        {/*Navbar*/}
        <NavBar/>
        <div>
          
        <Spline scene="https://prod.spline.design/4irsnlMOyjVtpcOp/scene.splinecode"/>
      
        </div>
       
        <Banner />
        <Model/>
        <Projects/> 
        <SupportEngine/>
        {/* <OpenAı/> */}
      
        </section>
    
    )   
}

//<NavBar/>


//<ThreeDModel/>

